// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPaymentMethodOwnerDto
 */
export interface IPaymentMethodOwnerDto {
    /**
     * 
     * @type {string}
     * @memberof IPaymentMethodOwnerDto
     */
    payment_method_owner_type: IPaymentMethodOwnerDtoPaymentMethodOwnerTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IPaymentMethodOwnerDto
     */
    employee_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IPaymentMethodOwnerDto
     */
    organization_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IPaymentMethodOwnerDto
     */
    provider_id?: number;
}

/**
* @export
* @enum {string}
*/
export enum IPaymentMethodOwnerDtoPaymentMethodOwnerTypeEnum {
    ORGANIZATION = 'ORGANIZATION',
    EMPLOYEE = 'EMPLOYEE',
    PROVIDER = 'PROVIDER'
}


/**
 * Check if a given object implements the IPaymentMethodOwnerDto interface.
 */
export function instanceOfIPaymentMethodOwnerDto(value: object): value is IPaymentMethodOwnerDto {
    if (!('payment_method_owner_type' in value) || value['payment_method_owner_type'] === undefined) return false;
    return true;
}

export function IPaymentMethodOwnerDtoFromJSON(json: any): IPaymentMethodOwnerDto {
    return IPaymentMethodOwnerDtoFromJSONTyped(json, false);
}

export function IPaymentMethodOwnerDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPaymentMethodOwnerDto {
    if (json == null) {
        return json;
    }
    return {
        
        'payment_method_owner_type': json['payment_method_owner_type'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'provider_id': json['provider_id'] == null ? undefined : json['provider_id'],
    };
}

export function IPaymentMethodOwnerDtoToJSON(json: any): IPaymentMethodOwnerDto {
    return IPaymentMethodOwnerDtoToJSONTyped(json, false);
}

export function IPaymentMethodOwnerDtoToJSONTyped(value?: IPaymentMethodOwnerDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'payment_method_owner_type': value['payment_method_owner_type'],
        'employee_id': value['employee_id'],
        'organization_id': value['organization_id'],
        'provider_id': value['provider_id'],
    };
}

